import { DOWNLOAD_INVOICE_OR_RECEIPT, DOWNLOAD_FILE } from "./actionTypes";

const downloadInvoiceOrReceipt = (transactionType, transactionId) => {
    return {
        type: DOWNLOAD_INVOICE_OR_RECEIPT,
        payload: {
            transactionType,
            transactionId
        },
        errors: null
    }
};

const downloadFile = ({itemType, fileId, fileName}) => ({
    type: DOWNLOAD_FILE,
    payload: {
        itemType, fileId, fileName
    }
})

export {
    downloadInvoiceOrReceipt, downloadFile
}